import React from 'react'
import RadioRowInput from '../../../../components/Atoms/RadioRowInput'
import {FormattedMessage} from 'react-intl'
import {FormikErrors} from 'formik'

export function CustomRadiosInput({
  data = [],
  value,
  onChange,
  error,
  required = false,
  label,
}: CustomRadiosInputProps) {
  return (
    <div className='my-1'>
      {label && <label className={`pb-1 fw-bold ${required ? 'required' : ''}`}>{label}</label>}
      {data.length ? (
        <div className='row'>
          {data.map((val, key) => (
            <div className='col-sm' key={key}>
              <RadioRowInput
                value={val.value}
                label={val.label}
                isActive={val.value == value}
                onClick={onChange}
                error={error ? true : false}
              />
            </div>
          ))}
        </div>
      ) : (
        <div className='row'>
          <div className='col-sm text-danger fw-bolder'>
            <FormattedMessage id='MENU.NO_RECORD_MATCH' />
          </div>
        </div>
      )}
      {error && (
        <div className='fv-plugins-message-container'>
          <div className='fv-help-block py-2'>
            <span className='text-danger fw-bold' role='alert'>
              {error}
            </span>
          </div>
        </div>
      )}
    </div>
  )
}

interface CustomRadiosInputProps {
  data: {label: string; value: string}[]
  value: string
  onChange: (value: string) => void
  error?: FormikErrors<string>
  required?: boolean
  label?: string | React.ReactNode
}
